import { SubAccountType } from '../enums';
import { validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';
import { IBalances } from '../types';
import { IPrimaryAccount, ISummaryData } from '../../../types';

export const getUserBalances = (summaryData: ISummaryData): IBalances => {
  const account = summaryData?.primaryAccount as IPrimaryAccount || summaryData?.accounts[0] as IPrimaryAccount;
  return {
    balance: account?.balance,
    taxBucketBalance: summaryData?.taxBucketBalance,
    emergencyBucketResponse: summaryData?.emergencyBucketResponse,
  };
};

export const getSubAccountResponse = (userBalances: IBalances, subAccountType: SubAccountType) => {
  switch (subAccountType) {
    case SubAccountType.taxBucket:
      return validateFeatureFlag(FEATURE_FLAG.TAX_BUCKET) ? userBalances?.taxBucketBalance : null;
    case SubAccountType.emergencyBucket:
      return validateFeatureFlag(FEATURE_FLAG.EMERGENCY_BUCKET) ? userBalances?.emergencyBucketResponse : null;
    case SubAccountType.emergencySavings:
      return validateFeatureFlag(FEATURE_FLAG.EMERGENCY_SAVING_ACCOUNT) ? userBalances?.emergencyBucketResponse : null;
    default:
      return null;
  }
};

export const getTotalCheckingBalance = (userBalances: IBalances) => {
  const taxBucketBalance = getSubAccountResponse(userBalances, SubAccountType.taxBucket)?.balance || null;
  const emergencyBucketBalance = getSubAccountResponse(userBalances, SubAccountType.emergencyBucket)?.balance || null;
  return userBalances.balance + (taxBucketBalance || 0) + (emergencyBucketBalance || 0);
};

export const getTotalSavingBalance = (userBalances: IBalances) => {
  const emergencySavingBalance = getSubAccountResponse(userBalances, SubAccountType.emergencySavings)?.balance || null;
  return emergencySavingBalance || 0;
};
